import * as React from 'react';
import { cn } from '@/lib/utils';

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'>
>(({ className, onInput, ...props }, ref) => {
  const innerRef = React.useRef<HTMLTextAreaElement>(null);

  React.useImperativeHandle(ref, () => innerRef.current as HTMLTextAreaElement);

  const resize = (el: HTMLTextAreaElement) => {
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, 360)}px`;
  };

  React.useEffect(() => {
    if (innerRef.current) resize(innerRef.current);
  }, [props.value]);

  return (
    <textarea
      className={cn(
        'flex min-h-[60px] max-h-[360px] w-full resize-none overflow-y-auto rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className
      )}
      ref={innerRef}
      onInput={(e) => {
        resize(e.currentTarget);
        onInput?.(e);
      }}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
